import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: true,
  selector: 'nggt-switcher',
  styleUrls: ['./switcher.component.scss'],
  imports: [CommonModule],
  template: `
    <label class="switch-label" [class.vertical]="vertical">
      <span class="first" [class.active]="vertical || isFirstValue()">
        {{ vertical ? currentValueLabel() : firstValueLabel }}
      </span>

      <div class="switch">
        <input type="checkbox" [checked]="isSecondValue()" (change)="changeValue()" />
        <span class="slider"></span>
      </div>

      <span *ngIf="!vertical" class="second" [class.active]="isSecondValue()">
        {{ secondValueLabel }}
      </span>
    </label>
  `,
})
export class SwitcherComponent {
  @Input() firstValue = '';
  @Input() secondValue = '';

  @Input() firstValueLabel = '';
  @Input() secondValueLabel = '';

  @Input() vertical = false;

  @Input() value = '';
  @Output() readonly valueChange = new EventEmitter<string>();

  isFirstValue() {
    return this.value === this.firstValue;
  }

  isSecondValue() {
    return this.value === this.secondValue;
  }

  currentValueLabel() {
    return this.isFirstValue() ? this.firstValueLabel : this.secondValueLabel;
  }

  changeValue() {
    this.value = this.isFirstValue() ? this.secondValue : this.firstValue;

    this.valueChange.emit(this.value);
  }
}
